import * as qs from 'qs';
import { axios } from '~/libs/axios';
import { type TNews } from '~/types';

const getAll = async (amount = 10) => {
  const queryParams = qs.stringify({ amount });
  const { data: news } = await axios.get<TNews[]>(
    '/news/recent?' + queryParams,
  );
  return news;
};

export const newsAPI = {
  getAll,
};
